import { render, staticRenderFns } from "./cdhkzyjsxy.vue?vue&type=template&id=20e4fc38&scoped=true&"
import script from "./cdhkzyjsxy.vue?vue&type=script&lang=js&"
export * from "./cdhkzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./cdhkzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cdhkzyjsxy.vue?vue&type=style&index=1&id=20e4fc38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e4fc38",
  null
  
)

export default component.exports